import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SuccessDialogData {
  isCreate: boolean;
  title: string;
  message: string;
}

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.scss'],
})
export class SuccessDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SuccessDialogData,
    private readonly dialogRef: MatDialogRef<SuccessDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.data.message = this.data.isCreate
      ? `The ${this.data.title} has been created successfully.`
      : `The ${this.data.title} has been updated successfully.`;
  }

  closeDialog(): void {
    // Close only this dialog rather than every open Material dialog.
    this.dialogRef.close();
  }
}
